import { FILE_STATUS, seriesColumnList } from '../constants';
import { tokens } from '../designTokens';

/** Maps a numeric `filestatus` from the API to its display label. */
export const getFileStatusLabel = (fileStatus: number): string =>
  Object.keys(FILE_STATUS).find((label) =>
    FILE_STATUS[label].includes(fileStatus),
  ) ?? 'Unknown';

/**
 * Colours for the status chip. Keyed by the label `getFileStatusLabel` returns,
 * which differs from `seriesColumnList.field` for the queue/progress statuses
 * ("Inqueue" vs "In queue"), so this mapping is explicit rather than derived.
 */
const STATUS_CHIP_COLORS: Record<string, { bg: string; fg: string }> = {
  Inqueue: { bg: tokens.status.inQueue, fg: tokens.colors.black },
  Inprogress: { bg: tokens.status.inProgress, fg: tokens.colors.black },
  'Patient Not Found': {
    bg: tokens.status.patientNotFound,
    fg: tokens.colors.black,
  },
  'Multiple Patients Found': {
    bg: tokens.status.multiplePatientsFound,
    fg: tokens.colors.white,
  },
  'Encounter Not Found': {
    bg: tokens.status.encounterNotFound,
    fg: tokens.colors.black,
  },
  'Document Not Found': {
    bg: tokens.status.documentNotFound,
    fg: tokens.colors.white,
  },
  Processed: { bg: tokens.status.processed, fg: tokens.colors.white },
  Failed: { bg: tokens.status.failed, fg: tokens.colors.white },
  'FYI Flag Found': { bg: tokens.status.fyiFlagFound, fg: tokens.colors.white },
  'Patient Mismatch': {
    bg: tokens.status.patientMismatch,
    fg: tokens.colors.white,
  },
  'Manual Processing Required': {
    bg: tokens.status.manualProcessingRequired,
    fg: tokens.colors.black,
  },
};

export const getStatusChipColors = (label: string) =>
  STATUS_CHIP_COLORS[label] ?? {
    bg: tokens.colors.lightGrey,
    fg: tokens.colors.black,
  };

/** Series colour lookup used by the charts, keyed by `SeriesColumn.field`. */
export const getSeriesColor = (field: string): string =>
  seriesColumnList.find((column) => column.field === field)?.color ??
  tokens.colors.grey;
